import React from 'react';
import { useNavigate } from 'react-router-dom';

// WEB DEMO ONLY: replaces the sign-in page. Nothing is checked - the visitor is the
// observer of a sample property.
function DemoStart() {
  const navigate = useNavigate();
  function start() {
    import('./demoEngine').then(m => {
      const who = m.DEMO_PEOPLE.floor;
      try {
        localStorage.setItem('token', who.token);
        localStorage.setItem('name', who.name);
        localStorage.setItem('role', who.role);
      } catch (e) { /* private window: the demo still works for this visit */ }
      navigate('/select-dealer');
    });
  }
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#1a1a2e', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px', gap: '24px', boxSizing: 'border-box' }}>
      <div style={{ width: '100%', maxWidth: '400px', backgroundColor: '#ffffff', borderRadius: '16px', padding: '18px 16px', boxSizing: 'border-box' }}>
        <img src="/logo.png" alt="EZ Pace" style={{ width: '100%', display: 'block' }} />
      </div>
      <div style={{ width: '100%', maxWidth: '400px', backgroundColor: '#16213e', borderRadius: '16px', padding: '28px 22px', boxSizing: 'border-box' }}>
        <div style={{ color: '#ffcc00', fontSize: '12px', fontWeight: 'bold', letterSpacing: '2px', marginBottom: '8px' }}>DEMO · FLOOR APP</div>
        <div style={{ color: '#ffffff', fontSize: '20px', fontWeight: 'bold', marginBottom: '10px' }}>Demo Casino</div>
        <div style={{ color: '#c0c0d0', fontSize: '15px', lineHeight: 1.55, marginBottom: '22px' }}>
          You are <b style={{ color: '#ffffff' }}>Olivia</b>, an observer on the floor. Pick a dealer, start a test and time
          a few rounds with the big buttons. Sample data only - nothing leaves this browser.
        </div>
        <button onClick={start} style={{ width: '100%', padding: '18px', backgroundColor: '#e94560', border: 'none', borderRadius: '10px', color: '#ffffff', fontSize: '18px', fontWeight: 'bold', cursor: 'pointer' }}>
          Start the demo
        </button>
      </div>
    </div>
  );
}

export default DemoStart;
